import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IShiftCoverageSummaryResponse } from 'types/api/shiftCoverageApi.interface'
import { IShiftCoverageSiteSummary, IShiftCoverageSlice } from 'types/shiftCoverage.interface'
import { baseUrl } from 'utils/axios'
import {
  buildDemoWidgetSummary,
  coverageSites,
  syncCoverageRegistries,
  USE_COVERAGE_MOCKS,
} from 'pages/Shifts/Coverage/coverageDemoStore'

const initialState: IShiftCoverageSlice = {
  isLoading: false,
  hasError: false,
  summaries: [],
}

export const getShiftCoverageSummary = createAsyncThunk(
  'shiftCoverage/getSummary',
  async (params: any, thunkAPI) => {
    if (USE_COVERAGE_MOCKS) {
      syncCoverageRegistries(thunkAPI.getState())
      return coverageSites().map((site) => ({ siteNodeId: site.id, ...buildDemoWidgetSummary(site.id) }))
    }
    try {
      const resp: AxiosResponse<IShiftCoverageSummaryResponse> = await baseUrl.get(
        'v1/shift-coverage/summary',
        { params },
      )
      return [{ siteNodeId: params?.siteNodeId || 1, ...resp.data }]
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const shiftCoverageSlice = createSlice({
  name: 'shiftCoverage',
  initialState,
  reducers: {},
  extraReducers: {
    [getShiftCoverageSummary.pending.type]: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    [getShiftCoverageSummary.fulfilled.type]: (
      state: IShiftCoverageSlice,
      { payload }: { payload: IShiftCoverageSiteSummary[] },
    ) => {
      state.isLoading = false
      state.summaries = payload
    },
    [getShiftCoverageSummary.rejected.type]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
  },
})

export default shiftCoverageSlice.reducer
